/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["sa",[["AM","PM"],u,["पूर्वाह्न","अपराह्न"]],[["AM","PM"]],[["र","सो","मं","बु","गु","शु","श"],["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],["रविवासरः","सोमवासरः","मंगलवासरः","बुधवासरः","गुरुवासर:","शुक्रवासरः","शनिवासरः"],["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"]],u,[["ज","फ","मा","अ","म","जू","जु","अ","सि","अ","न","दि"],["जनवरी:","फरवरी:","मार्च:","अप्रैल:","मई","जून:","जुलाई:","अगस्त:","सितंबर:","अक्तूबर:","नवंबर:","दिसंबर:"],["जनवरीमासः","फरवरीमासः","मार्चमासः","अप्रैलमासः","मईमासः","जूनमासः","जुलाईमासः","अगस्तमासः","सितंबरमासः","अक्तूबरमासः","नवंबरमासः","दिसंबरमासः"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["जनवरी:","फरवरी:","मार्च:","अप्रैल:","मई","जून:","जुलाई:","अगस्त:","सितंबर:","अक्तूबर:","नवंबर:","दिसंबर:"],["जनवरीमासः","फरवरीमासः","मार्चमासः","अप्रैलमासः","मईमासः","जूनमासः","जुलाईमासः","अगस्तमासः","सितंबरमासः","अक्तूबरमासः","नवंबरमासः","दिसंबरमासः"]],[["BCE","CE"]],0,[0,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##,##0%","¤#,##,##0.00","[#E0]"],"INR","₹","भारतीय रूप्यकम्",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
